// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card2_container {
  text-align: left;
  background: #ffffff;
  box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.12);
  border-radius: 15px;
  overflow: hidden;
  padding-bottom: 12px;
}
.card2_container h2,
.card2_container p,
.card2_container_option {
  padding: 0px 30px;
}
.card2 h2:first-child,
.card3 h2:first-child {
  font-size: var(--hSize);
  color: #264ec8;
}
.card2 h2:first-child span,
.card3 h2:first-child span {
  color: #e20f6f;
}
.card2_container h2 {
  color: #264ec8;
  font-size: var(--f20);
  margin-top: 25px;
}
.card2_container p {
  color: #323232;
  font-size: var(--pSize);
  margin-top: 12px;
}
.card2_container_option div {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}
.card2_container_option div:first-child span:first-child {
  color: var(--pink);
  font-size: var(--pSize);
}
.card2_container_btns a:first-child,
.card2_container_btns a:last-child {
  padding: 8px 20px;
  border-radius: 40px;
  font-size: 12px;
}
.card2_container_btns a:first-child {
  border: 2px solid #e20f6f;
  color: #264ec8;
  background: #ffffff;
}
.card2_container_btns a:last-child {
  background: #264ec8;
  border-radius: 40px;
  color: #fff;
  line-height: 2;
}
.rating {
  color: #ffe104 !important;
}
.card2 .card2_container .card2-img-wrapper {
  border-radius: 15px;
  height: 240px;
  width: 100%;
  object-fit: cover;
  overflow: hidden;
}

.card2 .card2_container .card2-img-wrapper img {
  width: 100%;
  height: 100%;
  border-radius: 15px !important;
}

/* .card3 .card2_container img {
  border-radius: 15px;
  height: 180px;
  width: 100%;
  object-fit: cover;
} */
.card2_container_option span {
  font-weight: 600;
  font-size: 14px;
}

.card2-title-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 30px;
}

.card2-title-wrapper > h2 {
  font-size: var(--f20) !important;
  margin: 0;
  padding: 0;
}

.card2-title-wrapper svg {
  font-size: 25px !important;
  color: var(--dPink);
}

.heart-icon {
  position: relative;
  /* font-size: 25px; */

  /* width: 50px; */
  /* height: 50px; */
  /* background: red; */
  border-radius: 50%;
  /* transition: transform 0.5s, opacity 0.5s; */
  /* animation: explode 1s forwards; */
}

@keyframes explode {
  0% {
    transform: scale(1);
    opacity: 1;
    font-size: 25px;
  }

  50% {
    transform: scale(2);
    opacity: 0.5;
    font-size: 22px;
  }
  100% {
    transform: scale(1);
    opacity: 1;
    font-size: 20px;
  }
}
.heart-icon,
.blonk-heart {
  color: var(--dPink);
}

.featured-container .owl-carousel .owl-item img {
  display: block;
  width: 100%;
  border-radius: 15px;
  height: 250px;
  object-fit: cover;
}

/* .featured-container .owl-carousel .owl-item img {
  height: 200px;
  width: auto;
} */
`, "",{"version":3,"sources":["webpack://./src/component/card2.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,4CAA4C;EAC5C,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;;;EAGE,iBAAiB;AACnB;AACA;;EAEE,uBAAuB;EACvB,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;AACA;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;AAChC;;AAEA;;;;;GAKG;AACH;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;;EAErB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,8CAA8C;EAC9C,oCAAoC;AACtC;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,UAAU;IACV,eAAe;EACjB;AACF;AACA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,iBAAiB;AACnB;;AAEA;;;GAGG","sourcesContent":[".card2_container {\r\n  text-align: left;\r\n  background: #ffffff;\r\n  box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.12);\r\n  border-radius: 15px;\r\n  overflow: hidden;\r\n  padding-bottom: 12px;\r\n}\r\n.card2_container h2,\r\n.card2_container p,\r\n.card2_container_option {\r\n  padding: 0px 30px;\r\n}\r\n.card2 h2:first-child,\r\n.card3 h2:first-child {\r\n  font-size: var(--hSize);\r\n  color: #264ec8;\r\n}\r\n.card2 h2:first-child span,\r\n.card3 h2:first-child span {\r\n  color: #e20f6f;\r\n}\r\n.card2_container h2 {\r\n  color: #264ec8;\r\n  font-size: var(--f20);\r\n  margin-top: 25px;\r\n}\r\n.card2_container p {\r\n  color: #323232;\r\n  font-size: var(--pSize);\r\n  margin-top: 12px;\r\n}\r\n.card2_container_option div {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-bottom: 12px;\r\n}\r\n.card2_container_option div:first-child span:first-child {\r\n  color: var(--pink);\r\n  font-size: var(--pSize);\r\n}\r\n.card2_container_btns a:first-child,\r\n.card2_container_btns a:last-child {\r\n  padding: 8px 20px;\r\n  border-radius: 40px;\r\n  font-size: 12px;\r\n}\r\n.card2_container_btns a:first-child {\r\n  border: 2px solid #e20f6f;\r\n  color: #264ec8;\r\n  background: #ffffff;\r\n}\r\n.card2_container_btns a:last-child {\r\n  background: #264ec8;\r\n  border-radius: 40px;\r\n  color: #fff;\r\n  line-height: 2;\r\n}\r\n.rating {\r\n  color: #ffe104 !important;\r\n}\r\n.card2 .card2_container .card2-img-wrapper {\r\n  border-radius: 15px;\r\n  height: 240px;\r\n  width: 100%;\r\n  object-fit: cover;\r\n  overflow: hidden;\r\n}\r\n\r\n.card2 .card2_container .card2-img-wrapper img {\r\n  width: 100%;\r\n  height: 100%;\r\n  border-radius: 15px !important;\r\n}\r\n\r\n/* .card3 .card2_container img {\r\n  border-radius: 15px;\r\n  height: 180px;\r\n  width: 100%;\r\n  object-fit: cover;\r\n} */\r\n.card2_container_option span {\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n}\r\n\r\n.card2-title-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 20px 30px;\r\n}\r\n\r\n.card2-title-wrapper > h2 {\r\n  font-size: var(--f20) !important;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.card2-title-wrapper svg {\r\n  font-size: 25px !important;\r\n  color: var(--dPink);\r\n}\r\n\r\n.heart-icon {\r\n  position: relative;\r\n  /* font-size: 25px; */\r\n\r\n  /* width: 50px; */\r\n  /* height: 50px; */\r\n  /* background: red; */\r\n  border-radius: 50%;\r\n  /* transition: transform 0.5s, opacity 0.5s; */\r\n  /* animation: explode 1s forwards; */\r\n}\r\n\r\n@keyframes explode {\r\n  0% {\r\n    transform: scale(1);\r\n    opacity: 1;\r\n    font-size: 25px;\r\n  }\r\n\r\n  50% {\r\n    transform: scale(2);\r\n    opacity: 0.5;\r\n    font-size: 22px;\r\n  }\r\n  100% {\r\n    transform: scale(1);\r\n    opacity: 1;\r\n    font-size: 20px;\r\n  }\r\n}\r\n.heart-icon,\r\n.blonk-heart {\r\n  color: var(--dPink);\r\n}\r\n\r\n.featured-container .owl-carousel .owl-item img {\r\n  display: block;\r\n  width: 100%;\r\n  border-radius: 15px;\r\n  height: 250px;\r\n  object-fit: cover;\r\n}\r\n\r\n/* .featured-container .owl-carousel .owl-item img {\r\n  height: 200px;\r\n  width: auto;\r\n} */\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
